/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, {createContext, useReducer} from "react";
import {SearchCond} from "../components/forms/SearchForm";
import {
  BASE_WORLD_LIST_SORT_ORDERS,
  BaseWorldListSortOrderValue,
  OBJECT_LIST_SORT_ORDERS,
  ObjectListSortOrderValue,
  WORK_SORT_ORDER,
  WorkSortOrderValue
} from "../../../constants/constants";
import {FindObjectResponse, ObjectDocument} from "../../../types/pj1dbApiObject";
import {Status, STATUSES} from "../../../hooks/useFetchAllQuery";
import {
  BaseWorldDocument,
  FindBaseWorldResponse,
  FindCustomWorldResponse,
  WorldDocument
} from "../../../types/pj1dbApiWorld";
import {FindWorkResponseData} from "../../../utils/awsAmplifyUtil";
import {WorkClassDocument, WorkInstanceDocument, WorkModelDocument} from "../../../types/pj1dbApiWork";
import {WORK_MODEL_SELECTION_STEP, WorkModelSelectionStep} from "../components/forms/WorkModelSelectionField";

export const WORLD_LIST_STEPS = {
  BASE_WORLD: 'base_world',
  CUSTOM_WORLD: 'custom_world',
}
export type WorldListStep = typeof WORLD_LIST_STEPS[keyof typeof WORLD_LIST_STEPS];


export const REGISTER_TYPES = {
  OBJECT: 'object',
  BASE_WORLD: 'base_world',
  CUSTOM_WORLD: 'custom_world',
}
export const REGISTER_TYPE_LABELS = {
  [REGISTER_TYPES.OBJECT]: '環境オブジェクト',
  [REGISTER_TYPES.BASE_WORLD]: 'ベースワールド',
  [REGISTER_TYPES.CUSTOM_WORLD]: 'カスタムワールド',
} as const;
export type RegisterType = typeof REGISTER_TYPES[keyof typeof REGISTER_TYPES];

export const BASE_WORLD_REGISTER_STEPS = {
  MODEL_SELECTION_STEP: 'model_selection_step',
  WORLD_NAME_INPUT_STEP: 'world_name_input_step',
}
export type BaseWorldRegisterStep = typeof BASE_WORLD_REGISTER_STEPS[keyof typeof BASE_WORLD_REGISTER_STEPS];

export const CUSTOM_WORLD_REGISTER_STEPS = {
  SELECTION_STEP: 'selection_step',
  WORLD_INFO_INPUT_STEP: 'world_info_input_step',
}
export type CustomWorldRegisterStep = typeof CUSTOM_WORLD_REGISTER_STEPS[keyof typeof CUSTOM_WORLD_REGISTER_STEPS];

// useReducerで生成する「参照用のstate」の型
export type DataStoreType = {
  tabIndex: number;
  objectList: {
    searchCond: SearchCond<ObjectListSortOrderValue>
    objects: FindObjectResponse[]
    searchStatus: Status
  };
  objectDetail: {
    object: ObjectDocument | null
    searchStatus: Status
  };
  worldDetail: {
    world: WorldDocument | null
    searchStatus: Status
  };
  worldList: {
    step: WorldListStep
    selectedBaseWorld: BaseWorldDocument | null
    customWorldSearchText: string
  };
  baseWorldList: {
    searchCond: SearchCond<BaseWorldListSortOrderValue>
    baseWorlds: FindBaseWorldResponse[]
    searchStatus: Status
  };
  customWorldList: {
    customWorlds: FindCustomWorldResponse[]
    searchStatus: Status
  };
  register: {
    type: RegisterType
  },
  objectRegister: {
    inputs: {
      files: File[]
    };
  },
  baseWorldRegister: {
    step: BaseWorldRegisterStep
    objectSearchCond: SearchCond<ObjectListSortOrderValue>
    objectSearchStatus: Status
    objects: FindObjectResponse[]
    inputs: {
      baseWorldFiles: File[]
      selectedObjects: ObjectDocument[],
      worldName: string
    };
    s3Uri: string | null;
  },
  customWorldRegister: {
    step: CustomWorldRegisterStep
    baseWorld: {
      items: FindBaseWorldResponse[]
      searchStatus: Status
      searchCond: SearchCond<BaseWorldListSortOrderValue>
    }
    workModelSelectionStep: WorkModelSelectionStep;
    workClass: {
      items: FindWorkResponseData<'class'>[]
      searchStatus: Status
      searchCond: SearchCond<WorkSortOrderValue>
      selected: WorkClassDocument | null
    }
    workInstance: {
      items: FindWorkResponseData<'instance'>[]
      searchStatus: Status
      selected: WorkInstanceDocument | null
    }
    workModel: {
      items: FindWorkResponseData<'model'>[]
      searchStatus: Status
    }
    inputs: {
      baseWorld: BaseWorldDocument | null
      workModels: WorkModelDocument[]
      customWorldConfigFiles: File[]
      generatedQuantity: string
      generationOption: {
        blockNumMax: string;
        placeStackNumRandom: boolean;
        gapSizeX: string;
        gapSizeY: string;
        marginMinX: string;
        marginMinY: string;
        fillRateRangeMin: string;
        fillRateRangeMax: string;
        workPosMisalignMaxRateX: string;
        workPosMisalignMaxRateY: string;
        abnormalOrienWorkExistMaxRate: string;
        mixedInWorkExistMaxRate: string;
      }
    };
  },
};

export const initialState: DataStoreType = {
  tabIndex: 0,
  objectList: {
    searchCond: {
      keyword: "",
      listCount: 0,
      sortOrder: OBJECT_LIST_SORT_ORDERS.OBJECT_NAME.value,
    },
    objects: [],
    searchStatus: STATUSES.IDLE
  },
  objectDetail: {
    object: null,
    searchStatus: STATUSES.IDLE
  },
  worldList: {
    step: WORLD_LIST_STEPS.BASE_WORLD,
    selectedBaseWorld: null,
    customWorldSearchText: "",
  },
  baseWorldList: {
    searchCond: {
      keyword: "",
      listCount: 0,
      sortOrder: BASE_WORLD_LIST_SORT_ORDERS.BASE_WORLD_NAME.value,
    },
    baseWorlds: [],
    searchStatus: STATUSES.IDLE
  },
  customWorldList: {
    customWorlds: [],
    searchStatus: STATUSES.IDLE
  },
  worldDetail: {
    world: null,
    searchStatus: STATUSES.IDLE
  },
  register: {
    type: REGISTER_TYPES.OBJECT,
  },
  objectRegister: {
    inputs: {
      files: []
    }
  },
  baseWorldRegister: {
    step: BASE_WORLD_REGISTER_STEPS.MODEL_SELECTION_STEP,
    objectSearchCond: {
      keyword: "",
      listCount: 0,
      sortOrder: OBJECT_LIST_SORT_ORDERS.OBJECT_NAME.value,
    },
    objectSearchStatus: STATUSES.IDLE,
    objects: [],
    inputs: {
      baseWorldFiles: [],
      selectedObjects: [],
      worldName: "",
    },
    s3Uri: null,
  },
  customWorldRegister: {
    step: CUSTOM_WORLD_REGISTER_STEPS.SELECTION_STEP,
    baseWorld: {
      items: [],
      searchStatus: STATUSES.IDLE,
      searchCond: {
        keyword: "",
        listCount: 0,
        sortOrder: BASE_WORLD_LIST_SORT_ORDERS.BASE_WORLD_NAME.value,
      },
    },
    workModelSelectionStep: WORK_MODEL_SELECTION_STEP.CLASS,
    workClass: {
      items: [],
      searchStatus: STATUSES.IDLE,
      searchCond: {
        keyword: "",
        listCount: 0,
        sortOrder: WORK_SORT_ORDER.NAME.value,
      },
      selected: null
    },
    workInstance: {
      items: [],
      searchStatus: STATUSES.IDLE,
      selected: null
    },
    workModel: {
      items: [],
      searchStatus: STATUSES.IDLE,
    },
    inputs: {
      baseWorld: null,
      workModels: [],
      customWorldConfigFiles: [],
      generatedQuantity: "",
      generationOption: {
        blockNumMax: "",
        placeStackNumRandom: false,
        gapSizeX: "",
        gapSizeY: "",
        marginMinX: "",
        marginMinY: "",
        fillRateRangeMin: "",
        fillRateRangeMax: "",
        workPosMisalignMaxRateX: "",
        workPosMisalignMaxRateY: "",
        abnormalOrienWorkExistMaxRate: "",
        mixedInWorkExistMaxRate: "",
      }
    },
  },
};

// dispatch関数の第2引数に渡す「action」の型
type ReducerActionType = {
  type: string;
  payload: any;
};

// createContext()のデフォルト値オブジェクトにasで割り当てる。
type DataStoreContextType = {
  state: DataStoreType;
  // dispatchの引数オブジェクトの型を、React.Dispatch<XXXXX> に定義する。
  dispatch: React.Dispatch<ReducerActionType>;
};

// reducer関数：更新用dispatchトリガーで、stateを更新する処理。
// 引数:   1.state 2.action(dispatch関数の引数)
// 戻り値: 更新後の新しいstate
export const CONTEXT_ACTION_TYPE = {
  TAB: "SET_TAB_INDEX",
  OBJECT_LIST: "SET_OBJECT_LIST",
  OBJECT_DETAIL: "SET_OBJECT_DETAIL",
  WORLD_LIST: "SET_WORLD_LIST",
  BASE_WORLD_LIST: "SET_BASE_WORLD_LIST",
  CUSTOM_WORLD_LIST: "SET_CUSTOM_WORLD_LIST",
  WORLD_DETAIL: "SET_WORLD_DETAIL",
  REGISTER: "SET_REGISTER",
  OBJECT_REGISTER: "SET_OBJECT_REGISTER",
  BASE_WORLD_REGISTER: "SET_BASE_WORLD_REGISTER",
  CUSTOM_WORLD_REGISTER: "SET_CUSTOM_WORLD_REGISTER",
} as const;

const reducerFunc = (state: DataStoreType, action: ReducerActionType) => {
  // action.typeの値で更新内容を切り替える。
  switch (action.type) {
    case CONTEXT_ACTION_TYPE.TAB:
      return {
        ...state,
        tabIndex: action.payload,
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.OBJECT_LIST:
      return {
        ...state,
        objectList: {
          ...state.objectList,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.OBJECT_DETAIL:
      return {
        ...state,
        objectDetail: {
          ...state.objectDetail,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.WORLD_LIST:
      return {
        ...state,
        worldList: {
          ...state.worldList,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.BASE_WORLD_LIST:
      return {
        ...state,
        baseWorldList: {
          ...state.baseWorldList,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.CUSTOM_WORLD_LIST:
      return {
        ...state,
        customWorldList: {
          ...state.customWorldList,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.WORLD_DETAIL:
      return {
        ...state,
        worldDetail: {
          ...state.worldDetail,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.REGISTER:
      return {
        ...state,
        register: {
          ...state.register,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.OBJECT_REGISTER:
      return {
        ...state,
        objectRegister: {
          ...state.objectRegister,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.BASE_WORLD_REGISTER:
      return {
        ...state,
        baseWorldRegister: {
          ...state.baseWorldRegister,
          ...action.payload,
        },
      } satisfies DataStoreType;
    case CONTEXT_ACTION_TYPE.CUSTOM_WORLD_REGISTER:
      return {
        ...state,
        customWorldRegister: {
          ...state.customWorldRegister,
          ...action.payload,
        },
      } satisfies DataStoreType;
    // 更新前のstateをそのまま返す。
    default:
      return state;
  }
};


// createContextはReactフックではないため、コンポーネント外で使用可能
// as でオブジェクトの型チェックをクリアする。
export const DataStoreContext = createContext({} as DataStoreContextType);

export function DataStoreContextProvider(props: any): JSX.Element {
  // useReducerで生成した「参照用state」と「更新用dispatch」を、contextに渡す。
  const [state, dispatch] = useReducer(reducerFunc, initialState);
  return (
    <DataStoreContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </DataStoreContext.Provider>
  );
}

export type TabIndexPayload = DataStoreType['tabIndex'];

export type ObjectListPayload = Partial<DataStoreType['objectList']>;

export type ObjectDetailPayload = Partial<DataStoreType['objectDetail']>;

export type WorldListPayload = Partial<DataStoreType['worldList']>;

export type BaseWorldListPayload = Partial<DataStoreType['baseWorldList']>;

export type CustomWorldListPayload = Partial<DataStoreType['customWorldList']>;

export type WorldDetailPayload = Partial<DataStoreType['worldDetail']>;

export type RegisterPayload = Partial<DataStoreType['register']>;

export type ObjectRegisterPayload = Partial<DataStoreType['objectRegister']>;

export type BaseWorldRegisterPayload = Partial<DataStoreType['baseWorldRegister']>;

export type CustomWorldRegisterPayload = Partial<DataStoreType['customWorldRegister']>;
